// Vue
import { createApp } from 'vue'
import { createPinia } from 'pinia'

// App
import App from './views/App.vue'

// Plugins
import mdiVue from 'mdi-vue/v3'
import * as icons from './icons'

// Styles
import '../css/app.css'

// Plugin files
import router from './router/router.js'
import { chunkLoadErrorMessages } from './utils/errors'

// Pinia store
import { useUserStore } from './stores/userStore.js'

import ClickOutsideDirective from './directives/clickOutsideDirective.js'

// Global components
import AppButton from './components/layout/button/AppButton.vue'
import AppSelect from './components/layout/select/AppSelect.vue'
import AppAddressSelect from './components/layout/select/AppAddressSelect.vue'
import AppInput from './components/layout/input/AppInput.vue'
import AppAutocomplete from './components/layout/autocomplete/AppAutocomplete.vue'
import AppContainer from './components/layout/container/AppContainer.vue'
import AppSpinner from './components/layout/loader/AppSpinner.vue'
import AppLabel from './components/layout/label/AppLabel.vue'
import AppRequiredLabel from './components/layout/label/AppRequiredLabel.vue'
import AppHelpLabel from './components/layout/label/AppHelpLabel.vue'
import AppErrorLabel from './components/layout/label/AppErrorLabel.vue'
import AppTooltip from './components/layout/tooltip/AppTooltip.vue'
import AppRadio from './components/layout/radio/AppRadio.vue'
import AppSwitch from './components/layout/switch/AppSwitch.vue'
import AppCheckbox from './components/layout/checkbox/AppCheckbox.vue'
import AppPickerCard from './components/layout/app-picker/AppPickerCard.vue'
import AppCard from './components/layout/card/AppCard.vue'
import AppAlertCard from './components/layout/alert/AppAlertCard.vue'
import AppModal from './components/layout/modal/AppModal.vue'
import AppTabs from './components/layout/tabs/AppTabs.vue'
import AppAccordion from './components/layout/accordion/AppAccordion.vue'

const pinia = createPinia()

const app = createApp(App)

app
  .component('AppButton', AppButton)
  .component('AppSelect', AppSelect)
  .component('AppAddressSelect', AppAddressSelect)
  .component('AppInput', AppInput)
  .component('AppAutocomplete', AppAutocomplete)
  .component('AppContainer', AppContainer)
  .component('AppTabs', AppTabs)
  .component('AppRadio', AppRadio)
  .component('AppSpinner', AppSpinner)
  .component('AppSwitch', AppSwitch)
  .component('AppCheckbox', AppCheckbox)
  .component('AppLabel', AppLabel)
  .component('AppRequiredLabel', AppRequiredLabel)
  .component('AppHelpLabel', AppHelpLabel)
  .component('AppErrorLabel', AppErrorLabel)
  .component('AppTooltip', AppTooltip)
  .component('AppPickerCard', AppPickerCard)
  .component('AppCard', AppCard)
  .component('AppAlertCard', AppAlertCard)
  .component('AppModal', AppModal)
  .component('AppAccordion', AppAccordion)
  .directive('click-outside', ClickOutsideDirective)
  .use(router)
  .use(pinia)
  .use(mdiVue, { icons })
  .mount('#app')

// Fetch the authenticated user when the app starts
const userStore = useUserStore()
userStore.fetchUser()

import('@sentry/vue').then((Sentry) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sendDefaultPii: false,
    ignoreErrors: chunkLoadErrorMessages,
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['labour-hub-vue'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        ignoreSentryInternalFrames: true,
      }),
    ],
  })
})
